import Styled from 'styled-components';

import { media } from '../../../../../lib/StyledComponents';
import { IPillProps, Pill } from '../../../../Pill';

export const TaskPill = Styled(Pill)<IPillProps>`
  margin: 0 0.75em 0.75em 0;

  ${media.small`
    margin: 0 0.75em;
    order: 2;
  `}
`;
